<p>tenant-widget-settings works!</p>
